import React from 'react';

import { Grid, TextareaAutosize } from '@mui/material';
import { LoadingButton } from '@mui/lab';
export { default } from '.';
export { default as SyncSelectedSitesPanel } from './SyncSelectedSitesPanel';

export const SyncAllSitesPanel = ({
	experimentalSites,
	setExperimentalSites,
	loading,
	fetchAndPopulateExperimentalSites,
	networkWideSyncHandler
}) => {
	return (
		<Grid container style={{ width: '100%' }}>
			<Grid item xs={12} style={{ margin: '3rem' }}>
				<TextareaAutosize
					minRows={8}
					maxRows={8}
					aria-label="maximum height"
					placeholder="Add Site IDs to exclude (1 Site ID per line)..."
					style={{ width: '100%', padding: '1rem', resize: 'none' }}
					value={experimentalSites.join('\n')}
					onChange={(e) => setExperimentalSites(e.target.value.split('\n'))}
					disabled={loading.experimentalSites}
				/>
			</Grid>
			<Grid item xs={2} style={{ marginLeft: '3rem', marginTop: '2rem' }}>
				<LoadingButton
					size="medium"
					type="submit"
					variant="contained"
					loading={loading.experimentalSites === true}
					onClick={fetchAndPopulateExperimentalSites}
					disabled={loading.experimentalSites === true}
				>
					Pull Experimental Sites
				</LoadingButton>
			</Grid>
			<Grid item xs={2} style={{ marginTop: '2rem' }}>
				<LoadingButton
					size="medium"
					type="submit"
					variant="contained"
					loading={loading.triggeringSync === true}
					onClick={networkWideSyncHandler}
					disabled={loading.triggeringSync === true}
				>
					Trigger Sync
				</LoadingButton>
			</Grid>
		</Grid>
	);
};
